module.exports = __webpack_public_path__ + "img/text_body_title.ec9e9f82.svg";